import {ACTION_CODE} from './_actionCode';
import {DealService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_DEAL';

export async function createDeal(
    userData: Record<string, string>,
    newDeal: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - createDeal - Start');

        const createDealResult = await DealService.createDeal(userData, newDeal);

        LoggerService.logInfo('Action - createDeal - End - Success');

        return ResultModel.newSuccessResult(createDealResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createDeal - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
